import { lazy, Suspense } from 'react';
import useSubstratePanelStore from '@/stores/substratePanelStore';
import LoadingSpinner from '@/components/ui/LoadingSpinner';
import LearnerProfileQuickView from './LearnerProfileQuickView';

const PeopleWorkspace = lazy(() => import('@/features/people/PeoplePage'));

/** The rail and full directory share the same data, profiles and mutations. */
export default function PeoplePanel({ isMatchingFullRoute = false }) {
  const panelContext = useSubstratePanelStore((state) => state.panelContext);

  if (panelContext?.kind === 'learner-profile' && panelContext.studentId) {
    return <LearnerProfileQuickView
      key={`${panelContext.studentId}:${panelContext.focusedEventId || ''}`}
      studentId={panelContext.studentId}
      focusedEventId={panelContext.focusedEventId}
    />;
  }

  if (isMatchingFullRoute) {
    return <div data-testid="people-workspace-slot" className="min-h-full" />;
  }

  return <Suspense fallback={<div className="flex justify-center p-8"><LoadingSpinner /></div>}>
    <PeopleWorkspace compact />
  </Suspense>;
}
